import MobileLayout from './FileUploaderInputLayout.mobile';
import WebLayout from './FIleUploaderInputLayout.web';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
